module.exports = __webpack_public_path__ + "static/media/Artboard_mobile.bd4c97bb.png";